import { useState, useEffect } from 'react';
import {EvaluationState} from "domain/entities/ResultsProps";
import {GUIDE_KEYS} from 'constants/app';
import {getEvaluationService} from "infrastructure/di/container";

// Crear instancia del servicio de evaluación
const evaluationService = getEvaluationService();

/**
 * Hook personalizado para manejar la evaluación de resultados según las ponderaciones
 * @param selectedForm Formulario seleccionado (Guia_II o Guia_III)
 * @param totalSum Suma total de puntos
 * @param categoryTotals Totales por categoría
 * @param domainTotals Totales por dominio
 * @returns Estado de las evaluaciones
 */
const useEvaluation = (
  selectedForm: string,
  totalSum: number,
  categoryTotals: { [category: string]: number },
  domainTotals: { [domain: string]: number }
): EvaluationState => {
  const [evaluations, setEvaluations] = useState<EvaluationState>({
    final: '',
    categories: {},
    domains: {}
  });

  useEffect(() => {
    const fetchAndEvaluate = async () => {
      if (selectedForm === GUIDE_KEYS.II || selectedForm === GUIDE_KEYS.III) {
        const ponderaciones = await evaluationService.getPonderaciones(selectedForm);

        if (ponderaciones &&
            Array.isArray(ponderaciones.categories) &&
            Array.isArray(ponderaciones.domains) &&
            ponderaciones.finalWeighting &&
            Array.isArray(ponderaciones.finalWeighting.rules)
        ) {
          const finalEvaluation = evaluationService.evaluateFinal(totalSum, ponderaciones);
          const categoriesEvaluations = evaluationService.evaluateCategories(categoryTotals, ponderaciones);
          const domainsEvaluations = evaluationService.evaluateDomains(domainTotals, ponderaciones);

          setEvaluations({
            final: finalEvaluation,
            categories: categoriesEvaluations,
            domains: domainsEvaluations
          });
        }
      }
    };

    fetchAndEvaluate();
  }, [selectedForm, totalSum, categoryTotals, domainTotals]);
  
  return evaluations;
};

export default useEvaluation;
